<template>
  <div class="basicInformation">
    <div class="card">
      <div class="CompanyName">{{ userName }}</div>
      <div class="df">
        <div class="security-label-characters df">
          <div class="security-label">
            <img
              class="security-label"
              src="@/assets/picture/security-label.png"
              alt=""
            />
          </div>
          <span>月结预存客户</span>
        </div>
        <div class="available-balance">
          <div class="available-balance1">可用余额</div>
          <div class="available-balance2">¥ {{info.balance? strFormat(info.balance):info.balance }}</div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="content">
        <div class="row df">
          <div class="name">可用余额</div>
          <div class="money">¥ {{info.balance? strFormat(info.balance):info.balance }}</div>
        </div>
        <div class="row df">
          <div class="name">累计充值金额</div>
          <div class="money">¥ {{info.rechargeAmount ? strFormat(info.rechargeAmount ):info.rechargeAmount }}</div>
        </div>
        <div class="row df">
          <div class="name">累计使用金额</div>
          <div class="money">¥ {{info.amountOfConsumption? strFormat(info.amountOfConsumption):info.amountOfConsumption }}</div>
        </div>
        <div class="row df">
          <div class="name">未核销金额</div>
          <div class="money">¥ {{info.noVerifyAmount ? strFormat(info.noVerifyAmount ):'' }}</div>
        </div>
        <div class="row df">
          <div class="name">本月发货金额</div>
          <div class="money">¥ {{ info.freezing ? strFormat(info.freezing ):info.freezing }}</div>
        </div>
      </div>
    </div>
    <noContent
      style="padding-top: 100px; text-align: center"
      v-if="!ISshow"
      img="1"
      explain="基本情况"
    ></noContent>
  </div>
</template>

<script>
import noContent from "@/components/noContent";
import API from "../../../api/prestore";
const api = new API();
export default {
  components: { noContent },
  data() {
    return {
      info: {},
      userName: window.localStorage.getItem("userName"),
      ISshow: true,
    };
  },
  methods: {
    async getReceivableMonthAmount() {
      let parme = {
        customerCode:window.localStorage.getItem("customerCode"),
      };
      let res = await api.getReceivableMonthAmount(parme);
      this.info = res;
    },
    strFormat(str) {
      str = str - 0;
      str = str + "";
      if (str) {
        if (str.split(".")[0].length > 3) {
          let lsit = [];
          str.split(".")[0].split("").reverse().map((i, index) => {
              if (index % 3 == 0 && index != 0) {
                lsit.push(",");
              }
              lsit.push(i);
            });
          return str.split(".")[1]
            ? lsit.reverse().join("") + "." + str.split(".")[1]
            : lsit.reverse().join("")+'.00';
        } else {
           if(str.split(".")[1]){
             return str.split(".")[0]+ '.'+str.split(".")[1]
           }else{
             return str+'.00'; 
           }
        }
      } else {
        return 0;
      }
    },
  },
  created() {
    this.getReceivableMonthAmount();
  },
};
</script>

<style lang='less' scoped>
.basicInformation {
  width: 100%;
  .card {
    font-size: 21px;
    font-weight: 500;
    color: #ffffff;
    line-height: 29px;
    margin: 55px auto;
    width: 400px;
    height: 229px;
    box-shadow: 0px 20px 70px -10px #6195e2;
    background-image: url("../../../assets/picture/basic-information.png");
    background-repeat: no-repeat;
    background-size: 101%;
    border-radius: 12px;
    position: relative;
    .CompanyName {
      position: absolute;
      top: 40px;
      left: 24px;
    }
    .security-label-characters {
      position: absolute;
      bottom: 31px;
      left: 24px;
      font-size: 14px;
      font-weight: 400;
      align-items: center;
      .security-label {
        line-height: 29px;
        margin-right: 5px;
        width: 20px;
        height: 20px;
      }
    }
    .available-balance {
      position: absolute;
      bottom: 29px;
      right: 33px;
      .available-balance1 {
        font-size: 11px;
        font-weight: 400;
        color: #ffffff;
        line-height: 16px;
        text-align: right;
      }
      .available-balance2 {
        font-size: 38px;
        // font-weight: bold;
        margin-top: 6px;
        font-family: DINCondensed-Bold, DINCondensed;
        color: #ffffff;
        font-weight: 500;
      }
    }
  }
  .box {
    margin: -4px auto;
    display: flex;
    justify-content: center;
    .content {
      .row {
        .name {
          width: 120px;
          text-align: left;
          height: 22px;
          font-size: 16px;
          color: rgba(50, 50, 51, 0.8);
        }
        .money {
          height: 22px;
          font-size: 16px;
          font-weight: 600;
          color: #323233;
          margin-top: 3px;
        }
      }
    }
  }
}
</style>